<template>
    <div class="success" id="container">
        <h1 class="title">恭喜您，领取成功！</h1>
        <div class="inform">已开通大智慧电脑版四维战法指标，<br/>有效期15天。</div>
        <p class="tips">如有疑问，请致电<a href="tel:021-20219988">021-20219999</a></p>
        <div class="download">
            <figure id="copyUrl" data-clipboard-target="#copyText">
                <span class="fl"><img src="../../assets/images/activity/1yuan365/pdt_05.jpg" alt="" /></span>
                复制下载链接
            </figure>
            <textarea id="copyText"></textarea>
            <p class="inform">请在PC端下载使用<br /><small>或在大智慧官网www.gw.com.cn下载</small></p>
        </div>
        <a href="###" class="btn-back">返 回</a>
        <div class="toolTip"></div>
    </div>
</template>

<script>
export default {
  data: function () {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
body{min-width: 100%;}
#container { max-width: 750px; margin: 0 auto;width:100%;}
html { font-size: 50px; }
@media screen and (min-width: 320px) { html { font-size: 42.7px; } }
@media screen and (min-width: 360px) { html { font-size: 48px; } }
@media screen and (min-width: 375px) { html { font-size: 50px; } }
@media screen and (min-width: 414px) { html { font-size: 55.2px; } }
body, button, input, select, textarea { font: 12px/1.4 "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", sans-serif; }
h1, h2, h3, h4, h5, h6, b, strong { font-weight: normal; }
button, input, select, textarea { padding: 0; background: none; border: 0; font-size: inherit; -webkit-appearance: none; appearance: none; }
textarea:focus, input:focus, button:focus { outline: 0; }
i { font-style: normal; }
a { text-decoration: none; }
img { display: block;margin: 0 auto; }
.flex { /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */ /* 老版本语法: Firefox (buggy) */ /* 混合版本语法: IE 10 */ /* 新版本语法: Chrome 21+ */ display: -webkit-flex; display: -ms-flexbox; display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */ -webkit-flex-wrap: nowrap; -ms-flex-wrap: nowrap; flex-wrap: nowrap; }
.flex > * { -webkit-flex: 1; -ms-flex: 1; flex: 1; }
.success{
    padding:1.2rem 1rem 0.4rem;background:#f9fcfd;height: 100vh;-webkit-box-sizing: border-box;box-sizing: border-box;
    .title{
        font-size: 0.48rem;color:#416dc2;line-height: 1.42rem;border-bottom: 0.06rem dashed #ced3e9;position: relative;
        &:after{content:'';position: absolute;right: 0;top:50%;width:0.94rem;height:1.1rem;margin-top:-0.56rem;background: url('../../assets/images/activity/1yuan365/icon-ok.png') no-repeat 0 0;-webkit-background-size: 100% auto;background-size: 100% auto;}
    }
    .inform{
        margin: 0.2rem 0;font-size:0.28rem;color: #243199;line-height: 1.8;
        strong{font-size: 0.32rem;font-weight: bold;}
        small{font-size: 0.22rem;color: #767777;}
    }
    .tips{
        font-size:0.22rem;margin-top: 0.5rem;color:#696b6b;
        a{
            font-size:0.28rem;color:#2795ef;
        }
    }
    .btn-back{
        position: absolute;bottom:5%;left:25%;width: 50%;background:#416dc2;line-height:0.72rem;border-radius:0.7rem;font-size: 0.38rem;color: #fff;text-align: center;
    }
    .download{
        margin-top: 0.4rem;
        textarea{position: absolute;opacity: 0;z-index: -1;}
        figure{
            background:#e7f2fb;border-radius: 0.2rem;padding: 0.1rem 0.16rem;line-height:1.44rem;text-align: center;font-size:0.34rem;color:#416dc2;position: relative;
            span.fl{
                width:1.3rem;height: 1.24rem;background:#fff;border-radius: 0.1rem;float: left;padding: 0.1rem 0.18rem;
                img{width: 100%;height: 100%;}
            }
        }
    }
    .toolTip{
        position:fixed;top: 45%;left: 35%;width: 30%;background: rgba(0, 0, 0, 0.5);line-height: 0.8rem;border-radius:0.08rem;font-size: 0.3rem;color: #fff;text-align: center;z-index: 10;display: none;
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/activity/Free333Success.vue